import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-categories-list',
  templateUrl: './categories-list.component.html'
})

export class CategoriesListComponent implements OnInit {

  url: string       = 'categories';

  data: Array<any>  = [];

  constructor(
    private dataService: DataService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService.getData(this.url).subscribe(response => {
      this.data = response.data;
    });
  }

  deleteData(id: string): void {
    if (!confirm('Desea eliminar el registro?')) {
      return;
    }

    this.dataService.deleteData(`${this.url}/delete/${id}`).subscribe(response => {

      if (response.rst) {
        this.messageService.add(response.msg, 'info');
      } else {
        this.messageService.add(response.msg, 'danger');
      }

      this.getData();
    });
  }
}
